module.exports = __webpack_public_path__ + "images/emoji/astonished.54003d52db6de8524ce3.png";